"use client";

import { ReactNode } from "react";
import { UIProvider } from "../context/UIContext";
import { SessionProvider } from "next-auth/react";

export default function Providers({ children }: { children: ReactNode }) {

  return (
    <UIProvider>
      <SessionProvider>{children}</SessionProvider>
    </UIProvider>
  );
}
